export default "__VITE_ASSET__RvgFuHba__"